export const SET_CAMPAIGN_SEARCH = 'SET_CAMPAIGN_SEARCH'
export const SET_PACKAGE_FILTER = 'SET_PACKAGE_FILTER'
export const SET_COMPANY_SEARCH = 'SET_COMPANY_SEARCH'
export const SET_USER_TYPE_FILTER = 'SET_USER_TYPE_FILTER'
export const SET_MANAGE_PACKAGE_FILTER = 'SET_MANAGE_PACKAGE_FILTER'
export const SET_MANAGE_SEARCH = 'SET_MANAGE_SEARCH'
export const SET_MANAGE_BRANDS_SEARCH = 'SET_MANAGE_BRANDS_SEARCH'
export const SET_MANAGE_END_DATE = 'SET_MANAGE_END_DATE'
export const SET_MANAGE_START_DATE = 'SET_MANAGE_START_DATE'

export const setCampaignSearch = payload => dispatch =>
  dispatch({
    type: SET_CAMPAIGN_SEARCH,
    payload: payload
  })
export const setPackageFilter = payload => dispatch =>
  dispatch({
    type: SET_PACKAGE_FILTER,
    payload: payload
  })
export const setManagePackageFilter = payload => dispatch =>
  dispatch({
    type: SET_MANAGE_PACKAGE_FILTER,
    payload: payload
  })
export const setCompanySearch = payload => dispatch =>
  dispatch({
    type: SET_COMPANY_SEARCH,
    payload: payload
  })
export const setUserType = payload => dispatch =>
  dispatch({
    type: SET_USER_TYPE_FILTER,
    payload: payload
  })
export const searchManageQuery = payload => dispatch =>
  dispatch({
    type: SET_MANAGE_SEARCH,
    payload: payload
  })
export const setManageBrandsFilter = payload => dispatch =>
  dispatch({
    type: SET_MANAGE_BRANDS_SEARCH,
    payload: payload
  })
export const setManageEndDate = payload => dispatch =>
  dispatch({
    type: SET_MANAGE_END_DATE,
    payload: payload
  })
export const setManageStartDate = payload => dispatch =>
  dispatch({
    type: SET_MANAGE_START_DATE,
    payload: payload
  })
